"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClipboard = exports.CustomSqlTextLink = exports.CustomSqlDialog = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const widgets_1 = require("@tableau/widgets");
const clipboard = tslib_1.__importStar(require("clipboard-polyfill"));
const react_1 = tslib_1.__importDefault(require("react"));
const CustomSqlStyles_1 = require("./CustomSqlStyles");
function CustomSqlDialog(props) {
    const title = props.selectedDropdownName
        ? `${catalog_messages_1.Messages.CustomSqlDialogTitle()}: ${props.selectedDropdownName}`
        : catalog_messages_1.Messages.CustomSqlDialogTitle();
    return (react_1.default.createElement(widgets_1.DialogWidget, { testId: 'Custom-Sql-Dialog', title: title, type: widgets_1.DialogType.NormalWithTitleBar, positioningBehavior: widgets_1.DialogPositioningBehavior.Draggable, showCloseButton: true, isModal: true, onCloseRequest: props.onClose, handleGlassClick: props.onClose, dialogWidth: CustomSqlStyles_1.customSqlDialogWidth, dialogHeight: CustomSqlStyles_1.customSqlDialogHeight, dialogBodyStyle: CustomSqlStyles_1.customSqlDialogStyle, footerContent: props.customSQLTables.length === 1
            ? react_1.default.createElement(RenderDialogFooter, { customSQLTables: props.customSQLTables })
            : null }, props.customSQLTables.map((table, index) => (react_1.default.createElement("ul", { key: index, className: CustomSqlStyles_1.customSqlQueryListClass },
        react_1.default.createElement("li", null,
            table.name,
            react_1.default.createElement("ul", { className: CustomSqlStyles_1.customSqlQuerySublistClass },
                react_1.default.createElement(RenderCustomSqlQueryText, { queryText: table.query }))),
        props.customSQLTables.length > 1
            ? (react_1.default.createElement(CopyToClipboard, { queryText: props
                    .customSQLTables[index]
                    .query, queryName: props.customSQLTables[index].name }))
            : null,
        index < props.customSQLTables.length - 1 ? react_1.default.createElement("div", { className: CustomSqlStyles_1.customSqlDividerClass }) : null)))));
}
exports.CustomSqlDialog = CustomSqlDialog;
function CopyToClipboard(props) {
    const onClick = useClipboard(props.queryText, props.queryName);
    return (react_1.default.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Outline, testId: 'CustomSql-Dialog-Copy', onClick: onClick, style: CustomSqlStyles_1.customSqlCopyButtonStyle }, catalog_messages_1.Messages.DialogCopy()));
}
function RenderDialogFooter(props) {
    const onClick = useClipboard(props.customSQLTables[0].query, props.customSQLTables[0].name);
    return (react_1.default.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Outline, testId: 'CustomSql-Dialog-Footer-Copy', onClick: onClick, className: CustomSqlStyles_1.customSqlSingleCopyButtonClass }, catalog_messages_1.Messages.DialogCopy()));
}
function RenderCustomSqlQueryText(props) {
    return (react_1.default.createElement("pre", { className: CustomSqlStyles_1.customSqlQueryTextClass },
        react_1.default.createElement("code", { className: CustomSqlStyles_1.codeTextClass }, props.queryText)));
}
function CustomSqlTextLink(props) {
    const [setIsDialogShowing, showDialog] = react_1.default.useState(false);
    const queryInfoButton = (react_1.default.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Outline, onClick: () => showDialog(true), testId: 'Custom-Sql-Text' }, catalog_messages_1.Messages.CustomSqlButtonTitle()));
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(widgets_1.InlineAlertWidget, { button: queryInfoButton, testId: 'Custom-SQL-Text-Alert', type: props.containsUnsupportedCustomSql ? widgets_1.InlineAlertType.Warning : widgets_1.InlineAlertType.Info, className: props.contentType === 'Workbook' || props.contentType === 'Flow'
                ? CustomSqlStyles_1.customSqlWorkbookInlineClass
                : CustomSqlStyles_1.customSqlGeneralInlineClass }, props.containsUnsupportedCustomSql ? warningInlineText(props.contentType) : infoInlineText(props.contentType)),
        setIsDialogShowing
            && (react_1.default.createElement(CustomSqlDialog, { customSQLTables: props.customSQLTables, onClose: () => showDialog(false), selectedDropdownName: props.selectedDropdownName }))));
}
exports.CustomSqlTextLink = CustomSqlTextLink;
function infoInlineText(contentType) {
    switch (contentType) {
        case 'Workbook':
            return catalog_messages_1.Messages.CustomSqlInfoInlineEmbeddedDatasource();
        case 'Flow':
            return catalog_messages_1.Messages.CustomSqlInfoInlineFlow();
        case 'PublishedDatasource':
            return catalog_messages_1.Messages.CustomSqlInfoInlinePublishedDatasource();
        case 'VirtualConnection':
            return catalog_messages_1.Messages.CustomSqlInfoInlineVirtualConnection();
        default:
            (0, catalog_core_1.assertUnreachable)(contentType);
            return '';
    }
}
function warningInlineText(contentType) {
    switch (contentType) {
        case 'Workbook':
            return catalog_messages_1.Messages.CustomSqlWarningInlineEmbeddedDatasource();
        case 'Flow':
            return catalog_messages_1.Messages.CustomSqlWarningInlineFlow();
        case 'PublishedDatasource':
            return catalog_messages_1.Messages.CustomSqlWarningInlinePublishedDatasource();
        case 'VirtualConnection':
            return catalog_messages_1.Messages.CustomSqlInfoInlineVirtualConnection();
        default:
            (0, catalog_core_1.assertUnreachable)(contentType);
            return '';
    }
}
function useClipboard(queryText, queryName) {
    const { popToast } = (0, catalog_core_1.useUIActions)();
    return react_1.default.useCallback((_) => {
        clipboard
            .writeText(queryText !== null && queryText !== void 0 ? queryText : '')
            .then(() => popToast('success', queryName ? catalog_messages_1.Messages.CustomSqlSuccessToast({ queryName: queryName }) : ''))
            .catch(() => popToast('error', catalog_messages_1.Messages.CustomSqlFailureToast()));
    }, [queryText, queryName, popToast]);
}
exports.useClipboard = useClipboard;
//# sourceMappingURL=CustomSqlDialog.js.map